import React, { Component } from 'react';

export default class Error404View extends Component {
	render() {
		return (
			<section className='hero is-danger is-fullheight'>			
		  		<div className='hero-body'>
				    <div className='container'>
				      <h1 className='title'>
				        Oeps!
				      </h1>
				      <h2 className='subtitle'>
				        404: Deze pagina bestaat niet
				      </h2>
				    </div>
				</div>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/views/Error404View.jsx.js